<template>
  <div class="">
    <cashier-header class="noprint">
      <template v-slot:mobile>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="showMenu = !showMenu"
        >
          <icon icon="align-justify" />
        </button>
      </template>
      <button class="btn btn-nav" @click="showMenu = !showMenu">
        <icon icon="align-justify" />
      </button>
    </cashier-header>
    <nav-vertical />
    <child />

    <div
      class="right-sidebar noprint"
      v-bind:class="{ show: showMenu }"
      id="right_side_bar"
    >
      <div class="card border-0">
        <div class="card-body pb-0">
          <a
            @click="showMenu = !showMenu"
            class="right_side_toggle float-right close-sidebar-icon"
          >
            <icon icon="arrow-right" />
          </a>
        </div>
        <div class="card-body pt-2">
          <div class="right-widget">
            <div class="custom-title-wrap bar-danger mb-4">
              <div class="custom-title">{{ $t("Cashier") }}</div>
              <h4>{{ user.firstname }} {{ user.lastname }}</h4>

              <h6 class="mb-0">
                <img
                  v-if="!restaurant.logo"
                  src="@/assets/images/store.svg"
                  width="30"
                  alt
                />
                <div
                  class="image-logo"
                  v-else
                  style="height: 30px; width: 30px;border-radius: 999px; background-size: cover "
                  :style="'background-image: url(' + restaurant.logo + ')'"
                ></div>

                {{ restaurant.name }}
              </h6>
            </div>
          </div>
          <div class="right-widget">
            <ul class="list-unstyled mb-0 list-widget">
              <li class="cursor right-nav right-nav" @click="open_dashboard">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <v-icon>mdi-view-dashboard-outline</v-icon>
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Dashboard") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li class="cursor right-nav" @click="open_order">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <v-icon>mdi-room-service-outline</v-icon>
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Create_Order") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li class="cursor right-nav" @click="openOrderList">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <icon icon="list" />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Order_List") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li class="cursor right-nav" @click="openReceivable">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <icon icon="file-text" />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Customer Bill") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="cursor right-nav"
                @click="(showCurrency = !showCurrency), (showMenu = !showMenu)"
              >
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <icon icon="dollar-sign" />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Currency") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="right-widget">
            <div class="custom-title-wrap bar-danger mb-4"></div>
            <ul class="list-unstyled mb-0 list-widget">
              <li class="cursor right-nav" @click="open_restaurants">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <img
                      src="@/assets/media/icons/duotone/Interface/Settings-02.svg"
                    />
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Switch") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li class="cursor right-nav" @click="changePassword">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <img
                      src="@/assets/media/icons/duotone/Interface/Lock.svg"
                    />
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Change_Password") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="cursor right-nav"
                @click="setting()"
                v-if="isSettingPrinter === 'true'"
              >
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <icon icon="settings" />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Settings") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
              <li
                class="cursor right-nav"
                @click="(modal_lang = !modal_lang), (showMenu = !showMenu)"
              >
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <icon icon="command" />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Languages") }}</h6>
                    </div>
                  </div>
                </div>
              </li>

              <li class="cursor right-nav" @click="logout()">
                <div class="media ">
                  <div class="st-alphabet mr-3">
                    <img
                      src="@/assets/media/icons/duotone/Interface/Sign-Out.svg"
                    />
                    <span class="status bg-warning"></span>
                  </div>
                  <div class="media-body">
                    <div class="float-left">
                      <h6 class="mb-0">{{ $t("Sign_Out") }}</h6>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="right-widget mt-5">
            <div>
              <div class="text-center mt-5">
                <span>Version: {{ version }}</span>
                <a class="nav-link px-0" href="#"
                  >© 2020 {{ $t("Copyright_by") }} DiscoverLaos</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal show_modal"
      v-if="showCurrency"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body" style="height: auto">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t("Currency") }}
            </h5>
            <br />

            <button
              class="btn btn-block btn-style-01"
              v-for="cus in restaurant.currencies"
              :key="cus.id"
              :class="{
                btn_currency_active: selected_currency.code === cus.code,
              }"
              @click="setCurrency(cus)"
            >
              {{ cus.title }} - {{ cus.code }}
            </button>
          </div>
          <!-- <div class="modal-footer">
            <button
              type="button"
              @click="showCurrency = false"
              class="btn btn-close"
              data-dismiss="modal"
            >
              {{ $t("Close") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal show_modal" v-if="modal_lang" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header"
            style="padding: 15px !important; border-bottom: 0"
          >
            <h5 class="modal-title">
              {{ $t("Language") }}
            </h5>
            <div class="close-header">
              <span @click="modal_lang = false">
                <icon icon="x" />
              </span>
            </div>
          </div>
          <div class="modal-body" style="height: auto">
            <button
              style="text-align: start;"
              class="col-4 btn btn-text"
              v-for="lang in langs"
              :key="lang.name"
              @click="setLocale(lang), (modal_lang = false)"
            >
              <img
                class="flag_icon"
                :src="require(`@/assets/flags/${lang.code}.svg`)"
                alt=""
              />
              {{ lang.name }}
            </button>
          </div>
          <!-- <div class="modal-footer">
            <button
              type="button"
              @click="modal_lang = false"
              class="btn btn-close"
              data-dismiss="modal"
            >
              {{ $t("Close") }}
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="css">
  .right-nav {
    display: inline-flex;
    width: 100%;
    padding: 8px;
    border-radius: 5px;
    margin: 0px 0px 5px 0px;
  }
  .right-nav:hover {
    background: #d6ddab36;
  }
  .btn-style-01 {
    border-width: 1px;
    border-style: dashed;
    color: #7e8299;
    border-color: #e4e6ef;
    background-color: rgba(245, 248, 250, 0.6);
    padding: 20px;
  }
  .btn_currency_active {
    color: #080808;
    border-color: #454f3a;
    background-color: #dce892;
  }
</style>

<script>
  import "../assets/scss/main.scss";
  import { loadMessages } from "../plugins/i18n";
  import store from "@/store";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import { version } from "../../version";

  export default {
    name: "Cashier",
    middleware: ["auth"],
    components: {
      VuePerfectScrollbar,
    },
    data() {
      return {
        showMenu: false,
        showCurrency: false,
        showLang: false,
        modal_lang: false,
        version,
      };
    },
    computed: {
      footer() {
        return store.getters["popup/footer"];
      },
      user() {
        return store.getters["auth/user"];
      },
      restaurant() {
        return store.getters["restaurant/restaurant"];
      },
      local() {
        return store.getters["lang/locale"];
      },
      langs() {
        return store.getters["lang/locales"];
      },
      isSettingPrinter() {
        return process.env.VUE_APP_AVAIBLE_PRINT_ORDER_TO_ROOM;
      },
      selected_currency() {
        return store.getters["currency/selected_currency"];
      },
    },
    methods: {
      openOrderList() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "order_list" }).catch((err) => {});
      },
      async logout() {
        this.showMenu = !this.showMenu;
        await store.dispatch("auth/signOut");
        await this.$router.push({ name: "login" });
      },
      setting() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "setting_printer" }).catch((err) => {});
      },
      changePassword() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "change_password" }).catch((err) => {});
      },
      open_dashboard() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "dashboard" }).catch((err) => {});
      },
      open_restaurants() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "restaurants" }).catch((err) => {});
      },
      open_order() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "home" }).catch((err) => {});
      },
      openReceivable() {
        this.showMenu = !this.showMenu;
        this.$router.push({ name: "receivable" }).catch((err) => {});
      },
      setCurrency(currency) {
        this.showCurrency = !this.showCurrency;
        this.$store.dispatch("currency/setCurrency", currency);
      },
      setLocale(lang) {
        if (!lang) return;
        if (this.$i18n.locale != lang.code) {
          loadMessages(lang.code);
          this.$store.dispatch("lang/setLocale", lang);
          this.lang = lang;
        }
      },
      HideMenu(value) {
        this.showMenu = false;
      },
    },
  };
</script>
